import { useContext } from 'react';

import { ToastContext } from '@/components/toast/context';
import type { ToastApi } from '@/components/toast/context';

/**
 * THROWS RATHER THAN RETURNING A NO-OP when the provider is missing. A silent no-op would mean a component
 * quietly stops reporting failures — which is the exact bug the toast was written to fix, reintroduced as a
 * missing wrapper nobody notices.
 */
export function useToast(): ToastApi {
  const api = useContext(ToastContext);

  if (api === null) {
    throw new Error('useToast must be used inside <ToastProvider>');
  }

  return api;
}
